import { useTranslation } from 'react-i18next';
import Sifra from '../../../../../../../../shared/components/Sifra';
import MantineGrid from '../../../../../../UI/MantineGrid/ManiteGrig';
import useHttp from '../../../../../../../hooks/use-http';
import { urls } from './api/urls';
import { useContext, useEffect } from 'react';
import { formatDateFromDB } from '../../../../../../../../utils/FormatDate';
import { TabContext } from '../../../../../../../Context/TabContext';
// import IzvestajRadnogNalogaDialog, {
//   TIP_IZVESTAJA,
// } from '../../../../../shared/IzvestajRadnogNaloga/IzvestajRadnogNalogaDialog';

const RNPURGridProvider = ({ idMasine }) => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);
  const { sendRequest, data, getData } = useHttp('');
  // const [pdfIdDok, setPdfIdDok] = useState(null);

  useEffect(() => {
    sendRequest({
      method: 'POST',
      url: urls.GET_RADNI_NALOG_ZA_MASINU,
      data: { id: idMasine },
    });
  }, []);

  const handleOpenDetail = (item) => {
    if (+localStorage.idFirme === 1) {
      const tab = {
        title: 'Pregled puštanja mašine',
        icon: 'fas fa-clipboard',
        type: 10022,
        data: item,
      };
      addTab(tab);
    } else {
      const tab = {
        title: 'Pregled servisa',
        icon: 'fas fa-clipboard',
        type: 10019,
        data: item,
      };
      addTab(tab);
    }
  };
  const handleClickDok = async (item) => {
    const tab = {
      title: 'Pregled zahteva',
      icon: 'fas fa-clipboard',
      type: 10014,
      data: { idDok: item.idDokServisnogZahteva },
    };
    addTab(tab);
  };
  const handleOpenDetaljiRadnogNaloga = async (item) => {
    item.id = item.idDok;
    const tab = {
      title: 'Detalji radnog naloga',
      icon: 'fas fa-chart-pie',
      type: 10016,
      data: item,
    };
    addTab(tab);
  };
  const columns = [
    // ...(localStorage.idFirme === '1'
    //   ? [
    //       {
    //         field: 'id',
    //         headerName: t('profit'),
    //         align: 'center',
    //         renderCell: (e) => (
    //           <Sifra
    //             displayValue="$"
    //             onClick={() => handleOpenDetaljiRadnogNaloga(e.row.original)}
    //           />
    //         ),
    //         size: 50,
    //       },
    //     ]
    //   : []),
    {
      field: 'ceoBrDok',
      headerName: t('workOrderId'),
      renderCell: (e) => (
        <Sifra
          displayValue={e.renderedCellValue}
          onClick={() => handleOpenDetail(e.row.original)}
        />
      ),
      // size: 300,
    },
    // ...(localStorage.sa === 'true'
    //   ? [
    //       {
    //         field: 'pdf',
    //         headerName: 'PDF',
    //         size: 70,
    //         renderCell: (e) => (
    //           <i
    //             className="fas fa-file-pdf"
    //             title={t('pdfReport')}
    //             style={{
    //               cursor: 'pointer',
    //               color: '#d32f2f',
    //               fontSize: '18px',
    //             }}
    //             onClick={() => setPdfIdDok(e.row.original.idDok)}
    //           />
    //         ),
    //       },
    //     ]
    //   : []),
    // {
    //   field: 'ceoBrDokServisnogZahteva',
    //   headerName: t('requestId'),
    //   renderCell: (e) => (
    //     <Sifra
    //       displayValue={e.renderedCellValue}
    //       onClick={() => handleClickDok(e.row.original)}
    //     />
    //   ),
    //   // size: 200,
    // },
    {
      field: 'datum',
      headerName: t('date'),
      renderCell: (e) => {
        return formatDateFromDB(e.row.original.datum);
      },
      // size: 200,
    },
    {
      field: 'statusDokumenta',
      headerName: t('orderStatus'),
      // size: 200,
    },
    {
      field: 'napomena',
      headerName: t('note'),
      size: 400,
    },
  ];

  console.log(columns);
  return (
    <div
      style={{
        marginTop: '10px',
        height: 'fit-content',
        width: '99%',
      }}
    >
      <MantineGrid columns={columns} data={data} />
      {/* <IzvestajRadnogNalogaDialog
        open={Boolean(pdfIdDok)}
        idDok={pdfIdDok}
        tip={TIP_IZVESTAJA.PUR}
        onClose={() => setPdfIdDok(null)}
      /> */}
    </div>
  );
};

export default RNPURGridProvider;
